import getRichTextSummary from '../../../RichText/getRichTextSummary';
import { FormField } from '../type';

type Formatter = (value: unknown, field?: any) => string;

type Specific<K extends string> = Extract<FormField, { blockType: K }>;

const fieldFormatters: Record<string, Formatter> = {
  checkboxGroup: (value: unknown, field: Specific<'checkboxGroup'>) => {
    if (!Array.isArray(value)) return String(value);
    return value
      .map((selected, index) =>
        selected ? getRichTextSummary(field?.options?.[index]?.label) : false,
      )
      .filter(Boolean)
      .join(', ');
  },
};

export const formatSubmissionData = (
  values: Record<string, unknown>,
  fields: FormField[],
): Record<string, string> => {
  const entries = Object.entries(values).map(([name, value]) => {
    const field = fields.find((f) => f.name === name);
    const format = field?.blockType
      ? fieldFormatters[field.blockType]
      : undefined;

    return [name, format ? format(value, field) : String(value)];
  });

  return Object.fromEntries(entries);
};
